import { type Components, type Theme } from "@mui/material/styles";

export const link: Components<Theme>["MuiLink"] = {
  defaultProps: {
    variant: "buttonSmall",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.primary.main,
      fontStyle: "normal",
      textDecorationLine: "underline",
      textDecorationStyle: "solid",
      textDecorationSkipInk: "none",
      textDecorationThickness: "auto",
      textUnderlineOffset: "auto",
      textUnderlinePosition: "from-font",
    }),
  },
};
